import React, { Fragment } from "react";
import CredHomeNFT from "./NFT";
import CredHomeProtocol from "./Protocol";
import { useCred } from "../../CredProvider";

export default function CredHomeSummary() {
  const { summary, isSummaryLoading } = useCred();

  return (
    <Fragment>
      <CredHomeNFT isLoading={isSummaryLoading} tier={summary?.highest_tier ?? "0"} boosts={summary?.highest_tier_boost ?? 0} />
      <CredHomeProtocol
        currentSeason={summary?.current_season ?? 0}
        totalCredEarned={summary?.total_cred_earned ?? 0}
        daysLeft={summary?.days_left}
        totalParticipants={summary?.total_participants_count ?? 0}
        isLoading={isSummaryLoading}
      />
    </Fragment>
  );
}
